module.exports = __webpack_public_path__ + "static/img/test1.dbbe693.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/test1.png
// module id = eG1c
// module chunks = 1